import React from "react";
import { useDeal } from "../lib/store";
import { Tile, ScopeTag, ScenarioBar } from "../components/shared";
import { PLCard, plCagr } from "../components/FinancialBlocks";
import * as m from "../lib/model";
import { AuditBadge } from "../components/AuditBadge";

export default function ProfitLoss() {
  const { M, V, scope, navigate, scenario, setScenario, scenFlash } = useDeal();
  const consolidated = m.isRollupScope(V);
  const viewTag = m.scopeLabel(M, scope);
  const gm = m.grossMargin(M);
  const cagr = plCagr(V);

  return (
    <div className={`page ${scenFlash ? "scen-flash" : ""}`} data-testid="page-profitloss">
      <div className="page-head">
        <div className="page-title">Profit &amp; Loss{viewTag && <span className="view-tag" data-testid="pl-view-tag">{viewTag}</span>}</div>
        <div className="page-sub">Reported years followed by the projection off your live assumptions — {consolidated ? "consolidated across the platform and all scheduled add-ons" : "this deal on its own"}.</div>
      </div>

      <div className="dash-ctlbar" data-testid="pl-controls">
        <ScopeTag M={M} value={scope} onEdit={() => navigate("assumptions")} testid="pl-scope" />
        <AuditBadge V={V} />
        <ScenarioBar value={scenario} onChange={setScenario} />
      </div>

      {!gm && (
        <div className="banner warn" data-testid="pl-no-gm">
          <span>⚠</span>
          <span>No gross margin recorded for this deal, so cost of goods and gross profit read zero. Set <b>Gross margin %</b> on Assumptions and every column below fills in.</span>
        </div>
      )}

      <div className="grid g4" style={{ marginBottom: 20 }}>
        <Tile label="TTM Revenue" value={m.fmt$(M.ttmRevenue)} sub="Platform, as reported" testid="pl-tile-rev" />
        <Tile label="Gross Margin %" value={gm ? m.fmtPct(gm) : "—"} sub={gm ? "Platform, as reported" : "set it on Assumptions"} testid="pl-tile-gm" />
        <Tile label="Adjusted EBITDA" value={m.fmt$(M.sde)} sub={M.ttmRevenue ? `${((M.sde / M.ttmRevenue) * 100).toFixed(1)}% margin` : undefined} testid="pl-tile-ebitda" />
        <Tile label={`Revenue CAGR (Y1–Y${cagr.years})`} value={cagr.pct ? m.fmtPct(cagr.pct) : "—"} sub={`${V.sdeGrowth}% growth assumption`} testid="pl-tile-cagr" />
      </div>

      <PLCard M={M} V={V} />
    </div>
  );
}
